import { http } from '@/lib/http';
import type { Page } from '@/types/common';
import type {
  AuditLogEntry,
  AuditLogQuery,
  PiiAccessLog,
} from '@/types/platform';

const BASE = '/api/v1/platform/audit';

export const auditService = {
  list: (query: AuditLogQuery = {}) =>
    http.get<Page<AuditLogEntry>>(BASE, { params: query }),
  /**
   * Records an operator's reveal of a masked PII field. Optimistic on the FE —
   * the value is shown immediately; this writes to the audit trail in the
   * background. See compliance addendum §A.5.
   */
  recordPiiAccess: (payload: PiiAccessLog) =>
    http.post<{ ok: true }, PiiAccessLog>(`${BASE}/pii-access`, payload),
};
